import { AuthenticationOptions } from '@pwc-bei/security';
import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthenticationServiceConfig implements AuthenticationOptions {
  cookieDomain = environment.cookieDomain;
  cookiePath = environment.cookiePath;
  frontendUrl = environment.appUrl;
  url = environment.authUrl;
  loginUrl = environment.appUrl;
}
